const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 11.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.27,4.91A2.46,2.46,0,1,0,9.82,2.45a2.46,2.46,0,0,0,2.45,2.46Zm-6.54,0A2.46,2.46,0,1,0,3.27,2.45,2.46,2.46,0,0,0,5.73,4.91Zm0,1.64C3.82,6.55,0,7.5,0,9.41v2H11.45v-2C11.45,7.5,7.63,6.55,5.73,6.55Zm6.54,0a7.72,7.72,0,0,0-.79,0,3.45,3.45,0,0,1,1.61,2.82v2H18v-2C18,7.5,14.18,6.55,12.27,6.55Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeopleIcon);
export default __webpack_public_path__ + "static/media/two-people-icon.7ddcf7518ce7bdd949ace63fd48e2d6f.svg";
export { ForwardRef as ReactComponent };